/* Service Booking Wizard — 3 steps.
 * Step 2 captures the lead via a Shopify contact form POST (full reload);
 * state survives via sessionStorage. Step 3 books a real slot through the
 * booking API when configured, with a Shopify-native callback fallback.
 */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('sbw');
  if (!root) return;

  var STORAGE_KEY = 'sbw-state-v1';
  var API_URL = (root.getAttribute('data-api-url') || '').replace(/\/+$/, '');
  // Non-blocking backend beacon (quote/event/booking persistence). Never blocks UI.
  // text/plain keeps it a CORS simple request (no preflight): Chrome refuses
  // keepalive fetches that need a preflight, which silently dropped the
  // booking/event beacons fired during a page navigation.
  function beacon(path, body, opts) {
    if (!API_URL) return Promise.resolve(null);
    return fetch(API_URL + path, Object.assign({
      method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body)
    }, opts || {})).then(function (r) { return r.ok ? r.json() : null; }).catch(function (err) {
      try { console.warn('AVS beacon failed:', path, err); } catch (e) { /* noop */ }
      return null;
    });
  }

  var state = loadState() || { stage: 'form', intent: 'priced', serviceId: '', service: '', units: 1, addOns: [], total: 0, name: '', email: '', phone: '', address: '' };

  function loadState() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
  }
  function saveState() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
  }
  function track(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    for (var k in params) payload[k] = params[k];
    window.dataLayer.push(payload);
  }
  function scrollToWizard() {
    var top = root.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  var booted = false;
  function showStep(step) {
    root.querySelectorAll('.sbw__step').forEach(function (el) {
      el.hidden = el.getAttribute('data-step') !== String(step);
    });
    root.querySelectorAll('.sbw__progress-step').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-progress'), 10);
      var current = typeof step === 'number' ? step : 4;
      el.classList.toggle('is-active', n === current);
      el.classList.toggle('is-done', n < current);
    });
    // booked/callback keep the progress visible with all steps marked done
    root.querySelector('.sbw__progress').hidden = step === 'posted-fallback';
    // The total bar is in-flow now — only show it on step 1 once a choice is made
    var tb = document.getElementById('sbwTotalBar');
    if (tb) {
      var hasSel = !!state.serviceId || (state.intent && state.intent !== 'priced');
      tb.hidden = !(step === 1 && hasSel);
    }
    updateRecap();
    // Premium step-enter animation (retrigger on each show)
    var vis = root.querySelector('.sbw__step:not([hidden])');
    if (vis) { vis.classList.remove('sbw__step--enter'); void vis.offsetWidth; vis.classList.add('sbw__step--enter'); }
    if (booted) scrollToWizard();
    if (typeof step === 'number') track('service_wizard_step', { wizard_step: step });
  }

  root.querySelectorAll('.sbw__next').forEach(function (btn) {
    btn.addEventListener('click', function () { showStep(parseInt(btn.getAttribute('data-next'), 10)); });
  });
  root.querySelectorAll('.sbw__back').forEach(function (btn) {
    btn.addEventListener('click', function () { showStep(parseInt(btn.getAttribute('data-back'), 10)); });
  });

  // ---- Step 1: catalog-driven service selection + instant price ----------
  var FALLBACK_CATALOG = {
    serviceTypes: [
      { id: 'highwall', label: 'High wall', plain: 'The common unit mounted high on the wall', price: 149.5, additionalPrice: 74.75, image: 'service-highwall' },
      { id: 'ducted', label: 'Ducted', plain: 'Hidden in the ceiling, vents in each room', price: 264.5, additionalPrice: 132.25, image: 'service-ducted' },
      { id: 'cassette', label: 'Ceiling cassette', plain: 'A square unit set into the ceiling', price: 149.5, additionalPrice: 74.75, image: 'service-cassette' },
      { id: 'floor', label: 'Floor console', plain: 'Sits low against the wall, near the floor', price: 149.5, additionalPrice: 74.75, image: 'service-floor' }
    ],
    addOns: [
      { id: 'deepclean', label: 'Deep clean', plain: 'Full strip-down detail', price: 120, coastalOnly: false },
      { id: 'coastal', label: 'Coastal anti-corrosion', plain: 'Salt-air protection', price: 214.08, coastalOnly: true },
      { id: 'mossmould', label: 'Moss & mould treatment', plain: 'Clears the outdoor unit', price: 145.85, coastalOnly: true }
    ]
  };

  // Small SVG glyphs per service type (no extra asset requests)
  var SERVICE_ICONS = {
    highwall: '<svg viewBox="0 0 48 32" fill="none"><rect x="3" y="5" width="42" height="13" rx="3" stroke="currentColor" stroke-width="2.2"/><path d="M9 13h22M9 9.5h26" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M14 22c0 3-3 3-3 5M24 22c0 3-3 3-3 5M34 22c0 3-3 3-3 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    ducted: '<svg viewBox="0 0 48 32" fill="none"><rect x="4" y="6" width="40" height="8" rx="2" stroke="currentColor" stroke-width="2.2"/><path d="M12 14v5m12-5v5m12-5v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M9 24h6m9 0h6m9 0h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" opacity=".5"/></svg>',
    cassette: '<svg viewBox="0 0 48 32" fill="none"><rect x="11" y="5" width="26" height="22" rx="3" stroke="currentColor" stroke-width="2.2"/><rect x="17" y="11" width="14" height="10" rx="2" stroke="currentColor" stroke-width="2"/></svg>',
    floor: '<svg viewBox="0 0 48 32" fill="none"><rect x="8" y="6" width="14" height="22" rx="3" stroke="currentColor" stroke-width="2.2"/><path d="M12 11h6M12 15h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M26 27h16" stroke="currentColor" stroke-width="2" stroke-linecap="round" opacity=".5"/></svg>'
  };

  var cardsWrap = document.getElementById('sbwServiceCards');
  var triageCards = root.querySelectorAll('.sbw__triage-card');
  var configPanel = document.getElementById('sbwConfig');
  var addonsWrap = document.getElementById('sbwAddons');
  var totalBar = document.getElementById('sbwTotalBar');
  var totalAmount = document.getElementById('sbwTotalAmount');
  var totalLabel = totalBar ? totalBar.querySelector('.sbw__total-label') : null;
  var totalNote = totalBar ? totalBar.querySelector('.sbw__total-note') : null;
  // Free-check / advice paths have no price — hide the "Your service" label and
  // "incl. GST" note so the bar just reads "Free check".
  function setTotalChrome(priced) {
    if (totalLabel) totalLabel.style.display = priced ? '' : 'none';
    if (totalNote) totalNote.style.display = priced ? '' : 'none';
    if (totalAmount) totalAmount.classList.toggle('sbw__total-amount--free', !priced);
  }
  var unitCountEl = document.getElementById('sbwUnitCount');
  var unitNoteEl = document.getElementById('sbwUnitNote');
  var step1Next = document.getElementById('sbwStep1Next');
  var catalog = FALLBACK_CATALOG;

  function money(n) {
    return '$' + n.toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function selectedType() {
    return catalog.serviceTypes.filter(function (t) { return t.id === state.serviceId; })[0] || null;
  }
  function computeTotal() {
    var t = selectedType();
    if (!t) return 0;
    var sum = t.price + Math.max(0, state.units - 1) * (t.additionalPrice || 0);
    state.addOns.forEach(function (id) {
      var a = catalog.addOns.filter(function (x) { return x.id === id; })[0];
      if (a) sum += a.price;
    });
    return Math.round(sum * 100) / 100;
  }

  // Slot-machine price roller: per-digit columns that translateY to target.
  function rollPrice(el, text) {
    var prev = el.getAttribute('data-val') || '';
    if (prev.length !== text.length) {
      el.innerHTML = '';
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        if (/\d/.test(ch)) {
          var col = document.createElement('span');
          col.className = 'sbw__roll';
          var strip = document.createElement('span');
          strip.className = 'sbw__roll-strip';
          strip.style.transitionDelay = (i * 30) + 'ms';
          for (var d = 0; d <= 9; d++) { var s = document.createElement('span'); s.textContent = d; strip.appendChild(s); }
          col.appendChild(strip);
          el.appendChild(col);
        } else {
          var sep = document.createElement('span');
          sep.className = 'sbw__roll-sep';
          sep.textContent = ch;
          el.appendChild(sep);
        }
      }
    }
    // set transforms (animates) — map each char position to its column/sep
    var nodes = el.childNodes, ni = 0;
    for (var j = 0; j < text.length; j++) {
      var c = text[j];
      var node = nodes[ni++];
      if (!node) break;
      if (/\d/.test(c)) {
        var strp = node.querySelector ? node.querySelector('.sbw__roll-strip') : null;
        if (strp) requestAnimationFrame(function (st, dig) { return function () { st.style.transform = 'translateY(-' + (dig * 10) + '%)'; }; }(strp, parseInt(c, 10)));
      } else {
        node.textContent = c;
      }
    }
    el.setAttribute('data-val', text);
  }

  function recapText() {
    if (state.intent && state.intent !== 'priced') return state.service;
    if (!state.serviceId) return '';
    var t = selectedType();
    var label = (t ? t.label : '') + ' service' + (state.units > 1 ? ' × ' + state.units : '');
    return label + ' · ' + money(state.total);
  }
  function updateRecap() {
    var txt = recapText();
    root.querySelectorAll('[data-recap]').forEach(function (el) {
      if (txt) { el.innerHTML = '<span class="sbw__recap-dot"></span>' + esc(txt); el.hidden = false; }
      else { el.hidden = true; }
    });
  }

  function refreshTotal() {
    state.total = computeTotal();
    rollPrice(totalAmount, money(state.total));
    updateRecap();
    var t = selectedType();
    if (unitNoteEl && t) {
      unitNoteEl.textContent = state.units > 1
        ? '+' + money(t.additionalPrice || 0) + ' each extra unit'
        : 'Extra units are discounted';
    }
  }

  function renderAddons() {
    var suburb = (state.suburb || '').toLowerCase();
    var coastal = /papamoa|mount|maunganui|omanu|pāpamoa|beach|marine|coast/.test(suburb);
    var ordered = catalog.addOns.slice().sort(function (a, b) { return (b.coastalOnly && coastal ? 1 : 0) - (a.coastalOnly && coastal ? 1 : 0); });
    addonsWrap.innerHTML = ordered.map(function (a) {
      var on = state.addOns.indexOf(a.id) !== -1;
      return '<button type="button" class="sbw__chip' + (on ? ' is-on' : '') + '" data-addon="' + esc(a.id) + '">' +
        '<span class="sbw__chip-check" aria-hidden="true"></span>' +
        '<span class="sbw__chip-label">' + esc(a.label) + '</span>' +
        '<span class="sbw__chip-price">+' + money(a.price) + '</span>' +
      '</button>';
    }).join('');
    addonsWrap.querySelectorAll('.sbw__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var id = chip.getAttribute('data-addon');
        var idx = state.addOns.indexOf(id);
        if (idx === -1) state.addOns.push(id); else state.addOns.splice(idx, 1);
        chip.classList.toggle('is-on');
        pulse(chip);
        refreshTotal();
        saveState();
      });
    });
  }

  function pulse(el) {
    el.classList.remove('sbw__pulse');
    void el.offsetWidth;
    el.classList.add('sbw__pulse');
    if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) {} }
  }

  function renderCards() {
    cardsWrap.innerHTML = catalog.serviceTypes.map(function (t) {
      return '<button type="button" class="sbw__card' + (t.id === state.serviceId ? ' is-selected' : '') + '" data-id="' + esc(t.id) + '" role="radio" aria-checked="' + (t.id === state.serviceId) + '">' +
        '<span class="sbw__card-icon">' + (SERVICE_ICONS[t.image] || SERVICE_ICONS[t.id] || '') + '</span>' +
        '<span class="sbw__card-body">' +
          '<span class="sbw__card-title">' + esc(t.label) + '</span>' +
          '<span class="sbw__card-plain">' + esc(t.plain) + '</span>' +
        '</span>' +
        '<span class="sbw__card-price">from ' + money(t.price) + '</span>' +
      '</button>';
    }).join('');
    cardsWrap.querySelectorAll('.sbw__card').forEach(function (card) {
      card.addEventListener('click', function () { selectService(card.getAttribute('data-id'), card); });
    });
  }

  function selectService(id, card) {
    state.intent = 'priced';
    state.serviceId = id;
    var t = selectedType();
    state.service = t ? t.label + ' service' : id;
    triageCards.forEach(function (c) { c.classList.remove('is-selected'); });
    cardsWrap.querySelectorAll('.sbw__card').forEach(function (c) {
      var on = c.getAttribute('data-id') === id;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-checked', on);
    });
    if (card) pulse(card);
    configPanel.hidden = false;
    totalBar.hidden = false;
    totalBar.classList.add('is-visible');
    setTotalChrome(true);
    step1Next.textContent = 'Continue';
    refreshTotal();
    saveState();
    track('service_wizard_step', { wizard_action: 'service_selected', service_type: state.service });
  }

  triageCards.forEach(function (c) {
    c.addEventListener('click', function () {
      state.intent = c.getAttribute('data-intent');
      state.serviceId = '';
      state.service = c.getAttribute('data-label');
      state.units = 1;
      state.addOns = [];
      state.total = 0;
      cardsWrap.querySelectorAll('.sbw__card').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', false); });
      triageCards.forEach(function (x) { x.classList.remove('is-selected'); });
      c.classList.add('is-selected');
      pulse(c);
      configPanel.hidden = true;
      totalBar.hidden = false;
      totalBar.classList.add('is-visible');
      setTotalChrome(false);
      rollPrice(totalAmount, 'Free check');
      saveState();
      track('service_wizard_step', { wizard_action: 'triage_selected', intent: state.intent });
    });
  });

  document.getElementById('sbwUnitMinus').addEventListener('click', function () {
    if (state.units > 1) { state.units--; unitCountEl.textContent = state.units; refreshTotal(); saveState(); }
  });
  document.getElementById('sbwUnitPlus').addEventListener('click', function () {
    if (state.units < 9) { state.units++; unitCountEl.textContent = state.units; refreshTotal(); saveState(); }
  });

  function initStep1() {
    renderCards();
    renderAddons();
    unitCountEl.textContent = state.units;
    if (state.serviceId) {
      configPanel.hidden = false;
      totalBar.hidden = false;
      totalBar.classList.add('is-visible');
      setTotalChrome(true);
      refreshTotal();
    } else if (state.intent && state.intent !== 'priced') {
      totalBar.hidden = false;
      setTotalChrome(false);
      rollPrice(totalAmount, 'Free check');
    }
    // Hydrate the real catalog from the API; re-render if it differs
    if (API_URL) {
      fetch(API_URL + '/api/services')
        .then(function (r) { if (!r.ok) throw new Error('svc ' + r.status); return r.json(); })
        .then(function (data) {
          if (data && data.serviceTypes && data.serviceTypes.length) {
            catalog = data;
            renderCards();
            renderAddons();
            if (state.serviceId) refreshTotal();
          }
        })
        .catch(function () { /* keep fallback catalog */ });
    }
  }

  // ---- Step 2: contact + lead submit --------------------------------------
  var leadForm = document.getElementById('ServiceLeadForm');
  var nameInput = document.getElementById('sbwName');
  var emailInput = document.getElementById('sbwEmail');
  var phoneInput = document.getElementById('sbwPhone');
  var addressInput = document.getElementById('sbwAddress');
  var toScheduleBtn = document.getElementById('sbwToSchedule');

  function validStep2() {
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
    var phoneOk = phoneInput.value.replace(/[^\d]/g, '').length >= 7;
    return nameInput.value.trim().length >= 2 && emailOk && phoneOk && addressInput.value.trim().length >= 5;
  }
  [nameInput, emailInput, phoneInput, addressInput].forEach(function (el) {
    el.addEventListener('input', function () { toScheduleBtn.disabled = !validStep2(); });
  });

  leadForm.addEventListener('submit', function (e) {
    if (!validStep2()) { e.preventDefault(); return; }
    state.name = nameInput.value.trim();
    state.email = emailInput.value.trim();
    state.phone = phoneInput.value.trim();
    state.address = addressInput.value.trim();
    state.stage = 'lead';
    saveState();
    document.getElementById('sbwFieldService').value = state.service;
    document.getElementById('sbwFieldUnits').value = String(state.units);
    var addonLabels = state.addOns.map(function (id) {
      var a = catalog.addOns.filter(function (x) { return x.id === id; })[0];
      return a ? a.label : id;
    }).join(', ');
    document.getElementById('sbwFieldAddons').value = addonLabels;
    document.getElementById('sbwFieldTotal').value = state.intent === 'priced' ? money(state.total) + ' incl GST' : 'Diagnostic / advice';
    toScheduleBtn.disabled = true;
    toScheduleBtn.textContent = 'One moment…';
    // native submit proceeds
  });

  // ---- Step 3: calendar -----------------------------------------------------
  var calendarWrap = document.getElementById('sbwCalendar');
  var slotsWrap = document.getElementById('sbwSlots');
  var confirmBtn = document.getElementById('sbwConfirmBooking');
  var errorEl = document.getElementById('sbwBookingError');
  var selectedSlot = null;

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function renderSlots(slots) {
    var byDate = {};
    slots.forEach(function (s) { (byDate[s.date] = byDate[s.date] || []).push(s); });
    slotsWrap.innerHTML = Object.keys(byDate).sort().map(function (date) {
      var day = byDate[date];
      return (
        '<div class="sbw__day">' +
          '<span class="sbw__day-label">' + esc(day[0].dayLabel) + '</span>' +
          '<div class="sbw__day-slots">' + day.map(function (s) {
            return '<button type="button" class="sbw__slot" data-slot-id="' + esc(s.id) + '" data-slot-label="' + esc(s.dayLabel + ', ' + s.windowLabel) + '"' + (s.available ? '' : ' disabled') + '>' + esc(s.windowLabel) + '</button>';
          }).join('') + '</div>' +
        '</div>'
      );
    }).join('');

    slotsWrap.querySelectorAll('.sbw__slot:not([disabled])').forEach(function (btn) {
      btn.addEventListener('click', function () {
        slotsWrap.querySelectorAll('.sbw__slot').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedSlot = { id: btn.getAttribute('data-slot-id'), label: btn.getAttribute('data-slot-label') };
        confirmBtn.disabled = false;
      });
    });
  }

  function loadSlots() {
    if (!API_URL) return;
    fetch(API_URL + '/api/slots')
      .then(function (r) { if (!r.ok) throw new Error('slots ' + r.status); return r.json(); })
      .then(function (data) {
        if (!data.slots || !data.slots.length) return;
        renderSlots(data.slots);
        calendarWrap.hidden = false;
        document.getElementById('sbwCallbackHeading').textContent = 'Prefer we call you to sort a time?';
      })
      .catch(function () { /* API down → callback-only, no error shown */ });
  }

  confirmBtn.addEventListener('click', function () {
    if (!selectedSlot) return;
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Booking…';
    errorEl.hidden = true;
    fetch(API_URL + '/api/bookings', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        slotId: selectedSlot.id,
        name: state.name,
        email: state.email,
        phone: state.phone,
        address: state.address,
        serviceType: state.service,
        units: state.units
      })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, status: r.status, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (res.status === 409) {
            errorEl.textContent = 'Sorry — that window just filled up. Pick another and we’ll lock it in.';
            loadSlots();
          } else {
            errorEl.textContent = 'Something went wrong booking that time. Try again, or request a callback below.';
          }
          errorEl.hidden = false;
          confirmBtn.textContent = 'Confirm my booking';
          confirmBtn.disabled = !selectedSlot;
          return;
        }
        state.stage = 'booked';
        state.bookedLabel = selectedSlot.label;
        saveState();
        track('service_booking_confirmed', { service_type: state.service, slot: selectedSlot.id });
        document.getElementById('sbwBookedSummary').textContent =
          state.service + ' — preferred time ' + selectedSlot.label + ', at ' + state.address + '.';
        showStep('booked');
      })
      .catch(function () {
        errorEl.textContent = 'Couldn’t reach the booking system. Request a callback below and we’ll sort it.';
        errorEl.hidden = false;
        confirmBtn.textContent = 'Confirm my booking';
        confirmBtn.disabled = false;
      });
  });

  // ---- Step 3: callback / preferred-time request ----------------------------
  // No Simpro yet — bookings are "preferred time" requests, earliest 2 weeks out.
  // Computed in JS (not Liquid) so it stays correct under Shopify CDN caching.
  var MIN_LEAD_DAYS = 14;
  var cbDate = document.getElementById('sbwCbDate');
  function isoDay(offsetDays) {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + offsetDays);
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var dd = ('0' + d.getDate()).slice(-2);
    return d.getFullYear() + '-' + mm + '-' + dd;
  }
  if (cbDate) {
    cbDate.min = isoDay(MIN_LEAD_DAYS);
    cbDate.max = isoDay(120);
    cbDate.addEventListener('input', function () { cbDate.setCustomValidity(''); });
  }

  var callbackForm = document.getElementById('ServiceCallbackForm');
  callbackForm.addEventListener('submit', function (e) {
    if (cbDate && cbDate.value && cbDate.value < cbDate.min) {
      e.preventDefault();
      cbDate.setCustomValidity('Our earliest service is about 2 weeks out — please pick a later date.');
      cbDate.reportValidity();
      return;
    }
    document.getElementById('sbwCbName').value = state.name;
    document.getElementById('sbwCbEmail').value = state.email;
    document.getElementById('sbwCbPhone').value = state.phone;
    document.getElementById('sbwCbDetails').value =
      state.service + ' | ' + state.units + ' unit(s) | ' + state.address +
      (cbDate && cbDate.value ? ' | preferred date ' + cbDate.value : '');
    state.stage = 'callback';
    saveState();
    track('service_request_submitted', { service_type: state.service });
    // Persist the service booking request to the backend (keepalive across reload)
    beacon('/api/bookings', {
      quoteId: state.quoteId || null, type: state.intent === 'priced' ? 'maintenance' : 'diagnostic',
      name: state.name, email: state.email, phone: state.phone, address: state.address,
      preferredDate: cbDate ? cbDate.value : '', preferredTime: document.getElementById('sbwCbTime').value,
      serviceType: state.service, summary: state.service + (state.units > 1 ? ' × ' + state.units : ''),
      units: state.units, idempotencyKey: 'sbw-book-' + (state.quoteId || state.email)
    }, { keepalive: true });
    beacon('/api/events', { surface: 'maintenance', event_name: 'booking_requested', quote_id: state.quoteId || null }, { keepalive: true });
    // native submit proceeds
  });

  document.getElementById('sbwStartOver').addEventListener('click', function () {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
    window.location.href = window.location.pathname + '#BookService';
    window.location.reload();
  });

  // ---- Boot -----------------------------------------------------------------
  initStep1();
  var posted = /[?&]contact_posted=true/.test(window.location.search);

  if (posted && state.stage === 'lead') {
    state.stage = 'schedule';
    saveState();
    track('generate_lead', {
      lead_type: 'service',
      service_type: state.service,
      units: state.units
    });
    // Persist the maintenance lead/quote to the unified backend (once) + event
    if (!state.quoteId) {
      beacon('/api/quotes', {
        flow_type: 'maintenance', intent: state.intent,
        summary: state.service + (state.units > 1 ? ' × ' + state.units : ''),
        total: state.intent === 'priced' ? state.total : null,
        name: state.name, email: state.email, phone: state.phone, address: state.address,
        payload: { serviceId: state.serviceId, units: state.units, addOns: state.addOns }
      }).then(function (r) {
        if (r && r.quoteId) { state.quoteId = r.quoteId; saveState(); }
        beacon('/api/events', { surface: 'maintenance', event_name: 'generate_lead', quote_id: state.quoteId || null });
      });
    }
    showStep(3);
    booted = true;
    scrollToWizard();
    loadSlots();
  } else if (posted && state.stage === 'callback') {
    showStep('callback');
    booted = true;
    scrollToWizard();
  } else if (state.stage === 'schedule' || state.stage === 'booked') {
    showStep(state.stage === 'booked' ? 'booked' : 3);
    if (state.stage === 'booked' && state.bookedLabel) {
      document.getElementById('sbwBookedSummary').textContent =
        state.service + ' — preferred time ' + state.bookedLabel + ', at ' + state.address + '.';
    }
    booted = true;
    if (state.stage === 'schedule') loadSlots();
  } else if (posted) {
    showStep('posted-fallback');
    booted = true;
    scrollToWizard();
  } else {
    state.stage = 'form';
    saveState();
    showStep(1);
    booted = true;
  }
});
